import { MODIFICA_LOADER } from '../actions/types'

const INITIAL_STATE = {
    showLoader: false,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MODIFICA_LOADER: 
            return {...state, showLoader: action.payload};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/LoaderReducer.js